import { __ } from '~@/Composables/translation'

export default {
    methods: {
        /**
         * @param targetElementToObserve
        * */
        preventEmailUrl (targetElementToObserve) {
            const targetNode = document.getElementById(targetElementToObserve)
            // Options for the observer (which mutations to observe)
            const config = { attributes: false, childList: true, subtree: true }

            // Callback function to execute when mutations are observed
            const callback = () => {
                const mailBody = document.getElementById('mailBody')
                if (mailBody !== null) {
                    const links = document.querySelectorAll('#mailBody a')
                    links.forEach((link) => {
                        link.addEventListener('click', function (e) {
                            e.preventDefault()

                            alert(__('tools.emails.prevent_url', { url: link.getAttribute('href') }))

                            e.stopImmediatePropagation()
                        })
                    })
                }
            }

            // Create an observer instance linked to the callback function
            const observer = new MutationObserver(callback)
            // Start observing the target node for configured mutations
            if (targetNode) {
                observer.observe(targetNode, config)
            }
        }
    }
}
